/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Move_Change_PlanInputs */



/**
* | output |
* | --- |
* | "Move to level" |
*
* @param {Gateway_Move_Change_PlanInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_move_change_plan = /** @type {((inputs?: Gateway_Move_Change_PlanInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Move_Change_PlanInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Move to level")
	return /** @type {LocalizedString} */ ("Déplacer vers le niveau")
});